// 在main.js上通过import引入Vue库和自己写的Vue组件库
import Vue from 'vue'
import Steps from './components/steps.vue'
import eventBus from './util/eventBus'


/**
 * Vue实例在setHtml方法中声明，初始化执行init的时候就能够创建
 * 声明Vue实例对象时，在其挂载完毕的生命周期里声明一个订阅，用于订阅update方法中发布的消息，从而更新实例数据
 * update方法中，发布一个消息，让Vue实例接收消息，更新数据
 * 在Vue实例的destroyed中，结束订阅
 * 注意loadFile中index.css的引入路径，因为webpack打包后将其放在了css文件夹里，所以路径是./css/index.css
 */
(function (KDApi) {
  function MyComponent(model) {
    this._setModel(model)
  }

  MyComponent.prototype = {
    _setModel: function (model) {
      this.model = model
    },
    init: function (props) {
      // console.log('-----init', this.model, props)
      setHtml(this.model, props)
    },
    update: function (props) {
      // console.log('-----update', this.model, props)
      eventBus.pub(this.model, 'update', props)
    },
    destoryed: function () {
      console.log('-----destoryed', this.model)
    }
  }

  const setHtml = (model, props) => {

    KDApi.loadFile('./css/index.css', model, () => {
      const { invoke, dom } = model
      const { data } = props
      new Vue({
        el: dom,
        template: '<Steps :invoke="invoke" :buildingBean="buildingObj" :opResult="opResult" :isOpResult="isOpResult" :model="model" :domainContextUrl="domainContextUrl" :isSaveAndPrint="isSaveAndPrint" :isSave="isSave" :baseUrl="baseUrl" :appId="appId" :fId="fId"/>',
        components: {
          Steps
        },
        data: {
          model: model,
          buildingObj: {},
          domainContextUrl:'',
          isSave:false,
          baseUrl:'',
          appId:'',
          fId:'',
          isSaveAndPrint:'',
          opResult:'',
          isOpResult:''
        },
        mounted() {
          const self = this

          this.updateSub = eventBus.sub(model, 'update', (props) => {
           
            const { data } = props
            this.isSave=false
            this.isSaveAndPrint=false
            this.isOpResult=false
            
            if(data.type=='shcprojectshow_save_set'){
                 console.log('点击保存设置后台返回接口',props)
                 this.isSave=true
            }
           
            if(data.type=='shcprojectshow_create_label_picture'){
                 console.log('点击打印后台返回接口',props)
                 this.isSaveAndPrint=true
            }
            if(data.type=='shcprojectshow_init_data'||data.type=='shcprojectshow_push_project_picture'||data.type=='shcprojectshow_save_data'||data.type=='shcprojectshow_save_data_and_print'){
                
                if(data.type=='shcprojectshow_init_data'){
                  console.log('初始化返回接口',props)
                }
                if(data.type=='shcprojectshow_push_project_picture'){
                  console.log('点击上传图片返回接口',props)
                }
                if(data.type=='shcprojectshow_save_data'){
                  console.log('保存设置饭回接口',props)
                }
                if(data.type=='shcprojectshow_save_data_and_print'){
                  console.log('打印返回接口',props)
                }
              if(data){
                self.domainContextUrl=data.domainContextUrl
                if(data.sourceHouseProjectShowBean){
                  self.buildingObj=data.sourceHouseProjectShowBean
                }
              }
              console.log('页面整体数据:',self.buildingObj)
            }
            if(data.type=='getImageBase64'){
              console.log('图片转base64返回接口',props)
              self.baseUrl=data ? data.getImageBase64 :''
            }
            
            if(data.type=='shcprojectshow_user_changed_record'){
              console.log('打印弹框点击是否返回接口',props)
              this.isOpResult=true
              this.opResult=data ? data.opResult :''
          }
            
            // if()
            // if( self.buildingObj.sourceHouseProjectShowBuildBeanList != undefined ||  self.buildingObj.sourceHouseProjectShowBuildBeanList.length > 0){
            //   let flagnum=0
            //   self.buildingObj.sourceHouseProjectShowBuildBeanList.forEach((i)=>{
            //     if(i.label)
            //     {
            //       self.$set(i,'showLabel',0)
            //     }else{
            //       flagnum++;
            //       self.$set(i,'showLabel',flagnum)
            //     }
            //   })           
            // }
            
          })
        },
        destroyed() {
          eventBus.unsub(this.updateSub)
        },
        methods: {
          invoke: (eventName, args) => {
            invoke(eventName, args)
          },
          getLangMsg: (key) => {
            return KDApi.getLangMsg(model, key)
          },
          getNameSpace:()=>{
            return KDApi.getNameSpace(model)
           
          }
        }
      })
    })
  }

  // 注册自定义组件
  KDApi.register('resalshcprojectshow', MyComponent, {
    isMulLang: true
  })
})(window.KDApi)
